import type { AndroidSigningKey, OtaSigningChannel } from './types';

/**
 * R2 / API use the artifact variant segments `app-signed` (standard key) and `platform-signed`
 * (platform key). UI always speaks in signing-key terms to avoid conflating with release channels.
 */

export function signingKeyFromArtifactBucket(bucket: OtaSigningChannel): AndroidSigningKey {
  return bucket === 'platform-signed' ? 'platform' : 'standard';
}

export function artifactBucketFromSigningKey(key: AndroidSigningKey): OtaSigningChannel {
  return key === 'platform' ? 'platform-signed' : 'app-signed';
}

export function signingKeyLabel(key: AndroidSigningKey): string {
  return key === 'platform' ? 'Platform key' : 'Standard key';
}

export function signingKeyShortLabel(key: AndroidSigningKey): string {
  return key === 'platform' ? 'Platform' : 'Standard';
}

export function signingKeyDescription(key: AndroidSigningKey): string {
  return key === 'platform'
    ? 'Signed with the vendor platform key for proprietary Vortex Android (OEM / branding builds).'
    : 'Signed with the standard app key for the main Vortex Android fleet.';
}

export function signingKeyBadgeTone(key: AndroidSigningKey): 'warning' | 'blue' {
  return key === 'platform' ? 'warning' : 'blue';
}
